import { useQuery, useMutation, useQueryClient } from 'react-query';
import { ProjectService as ps } from '../api/ProjectService';

export function useFetchProjects() {
  const { data, error, isLoading, isFetching } = useQuery(
    'projects',
    async () => {
      const response = await ps.fetchProjects();
      return response.projectsList;
    },
    {}
  );

  return { data, error, isLoading, isFetching };
}

// Project Hierarchy Hooks
export function useFetchProjectHierarchy(userId: string) {
  const { data, error, isLoading, isFetching } = useQuery(
    ['projectHierarchy', userId],
    async () => {
      const response = await ps.getProjectHierarchy();
      return response.projecthierarchiesList;
    },
    {}
  );

  return { data, error, isLoading, isFetching };
}

export function useCreateProjectHierarchy(userId: string) {
  const queryClient = useQueryClient();

  return useMutation(
    async (hierarchyData: {
      parentid?: string;
      code: string;
      name: string;
      description?: string;
      isactive?: boolean;
    }) => {
      return await ps.createProjectHierarchy(hierarchyData);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['projectHierarchy', userId]);
      },
    }
  );
}

export function useUpdateProjectHierarchy(userId: string) {
  const queryClient = useQueryClient();

  return useMutation(
    async (hierarchyData: {
      id: string;
      parentid: string;
      code: string;
      name: string;
      description: string;
      isactive: boolean;
    }) => {
      return await ps.updateProjectHierarchy(hierarchyData);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['projectHierarchy', userId]);
      },
    }
  );
}

export function useDeleteProjectHierarchy(userId: string) {
  const queryClient = useQueryClient();

  return useMutation(
    async (id: string) => {
      return await ps.deleteProjectHierarchy(id);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['projectHierarchy', userId]);
      },
    }
  );
}
